<template>
    <div class="h-100" id="app">
      <router-view/>
    </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
a {
  color: white
}

html {
  height: 100%;
}

body {
  min-height: 100%;
  background: #313d4a;
  display: flex;
  flex-direction: column;
  font-family: "azo-sans-web", Helvetica Neue, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}

#app {
  margin-top: 60px;
  flex: 1;
  z-index: 0;
}

@media screen and (max-width: 960px) {
  #app {
    margin-top: 90px;
    flex: 1;
    z-index: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue